const DetailInstruction=()=>{

}
export default DetailInstruction